package com.anjuros.website.pages.blog

import androidx.compose.runtime.Composable
import com.anjuros.website.redesign.sections.blogarticle.BlogArticlePage
import com.anjuros.website.templates.selection.modules.BlogCard
import com.varabyte.kobweb.core.Page

@Page("15-essential-features-every-sole-trader-website-should-have")
@Composable
fun EssentialFeaturesEverySoleTraderWebsiteShouldHave() {
    BlogArticlePage(BlogCard.BLOG3)
}
